module.exports = __webpack_public_path__ + "images/mobile/home/screenshot-discuss@2x-46fcee21b840df92d9469585b7531832.png";